import stringWidth from './stringWidth'
import drawRect from './drawRect'

const fontFamily = '"Noto Sans", -apple-system, BlinkMacSystemFont, Helvetica, Arial, sans-serif'

const drawText = ({
  x = 0,
  y = 0,
  fontWeight = '600',
  textBaseline = 'middle',
  fontSize,
  fillStyle,
  bgFillStyle,
  text,
  context,
  center,
  shadow = true,
  inline, // Applied only with bgFillStyle. Adds padding offset to initial x
  selected,
}) => {
  if (!text) {
    return
  }
  const horizontalPadding = fontSize * 0.6

  context.textBaseline = textBaseline
  const w = stringWidth({ text, fontSize, context })

  if (center) {
    x -= w / 2
  }

  if (inline && bgFillStyle) {
    x += horizontalPadding
    y += fontSize
  }

  if (bgFillStyle) {
    drawRect({
      x: x - horizontalPadding,
      y: y - fontSize,
      w: w + horizontalPadding * 2,
      h: fontSize * 2,
      fillStyle: bgFillStyle,
      context,
      radius: 2,
    })
  }

  if (selected) {
    drawRect({
      x: x - (1.2 * w) / 2,
      y: y - fontSize,
      w: (w / 2) * 2.4,
      h: fontSize * 2,
      strokeStyle: 'cornflowerblue',
      lineWidth: 3,
      context,
    })
  }

  if (shadow) {
    context.strokeStyle = 'white'
    context.lineWidth = fontSize / 6
    context.font = `${fontWeight} ${fontSize}px ${fontFamily}`
    context.strokeText(text, x, y)
  }

  context.font = `${fontWeight} ${fontSize}px ${fontFamily}`
  context.fillStyle = fillStyle
  context.fillText(text, x, y)
}

export default drawText
